<div class="widget">
  <div class="amSuite-widget-header">
    {{'widgets.activity-graphs.state-graph.title' | translate}}
    @if (modify) {
      <a href="javascript:void(0)" (click)="actpop()" class="modify-btn"
        pTooltip="{{'widgets.user-activities.edit' | translate}}">
        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
      </a>
    }
    @if (!modify) {
      <small class="date-font"><i>({{initialDate | date: 'shortDate'}} -
      {{finalDate | date:'shortDate'}})</i></small>
    }
  </div>
  <div class="graph-widget amSuite-widget-block height-auto">
    @switch (status) {
      @case ('ready') {
        <div class="state-card">
          <div class="kpi-wrap">
            <p-chart type="doughnut" [data]="dataOfState" height="190px" [options]="graphOptions"></p-chart>
            <div class="kpi-center">
              <div class="kpi-value">{{ totalActivities }}</div>
              <div class="kpi-label">{{ 'widgets.activity-graphs.state-graph.total-label' | translate }}</div>
            </div>
          </div>
          <div class="legend">
            <div class="lg-item lg-open">
              <span class="lg-dot" aria-hidden="true"></span>
              <span class="lg-name">{{ 'chart-view.label-opened' | translate }}</span>
              <span class="lg-count">{{ stateStats.opened }}</span>
            </div>
            <div class="lg-item lg-work">
              <span class="lg-dot" aria-hidden="true"></span>
              <span class="lg-name">{{ 'chart-view.label-working' | translate }}</span>
              <span class="lg-count">{{ stateStats.working }}</span>
            </div>
            <div class="lg-item lg-closed">
              <span class="lg-dot" aria-hidden="true"></span>
              <span class="lg-name">{{ 'chart-view.label-closed' | translate }}</span>
              <span class="lg-count">{{ stateStats.closed }}</span>
            </div>
          </div>
        </div>
      }
      @case ('busy') {
        <div style="display: flex; justify-content: center; align-items: center; min-height: 200px;">
          <p-progressSpinner strokeWidth="3" animationDuration="1s"></p-progressSpinner>
        </div>
      }
    }
  </div>
</div>
